import { CognitoUserPool } from "amazon-cognito-identity-js";

const poolData = {
  UserPoolId: "eu-central-1_yaXk3lIhE",
  ClientId: "17vcsogbcoea7as9upige5dgcc",
};

export default new CognitoUserPool(poolData);